module.exports = __webpack_public_path__ + "img/exhibitionHall2.e31c0255.png";